import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, RouterModule } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authConfig } from './app/auth/auth.config';
import { provideAuth } from 'angular-auth-oidc-client';
import { AuthInterceptor } from './app/auth/auth.interceptor';
import { adminEnvironment } from './environments/environment';
import { enableProdMode } from '@angular/core';

if (adminEnvironment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () { };
  }
}

if (adminEnvironment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () { };
  }
}
console.log('[ADMIN ENV]', adminEnvironment.aws?.cognito?.userPoolId);

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideAuth(authConfig),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
}).catch((err) => console.error(err));
